import axios from "@/api/axiosInstance";
import { AdoptionSummary, GetAdoptionSummaryResponse } from "./types";

export const getAdoptionSummary = async (
  signal?: AbortSignal,
): Promise<AdoptionSummary> => {
  const response = await axios.get<GetAdoptionSummaryResponse>(
    "/api/private/admin/data-connector-adoption/summary",
    { signal },
  );
  return response.data.data;
};
